export default {
  namespaced: true,
  state: {
    timeout: 3000,
    maxNotifications: 5,
    list: [
      // Example:
      // {
      //   type: 'info', // warning, danger, success, etc.
      //   message: 'message text'
      // }
    ]
  },
  mutations: {
    addNotification (state, payload) {
      if (state.list.length === state.maxNotifications) state.list.shift()
      state.list.push(payload.notification)
      setTimeout(() => state.list.shift(), state.timeout)
    }
  }
}
